export const CLOSE_DELAY = 150;
export const RIGHT_CLASS = 'react-context-menu__submenu-right';
export const BOTTOM_CLASS = 'react-context-menu__submenu-bottom';

export const HIDE_ON_EVENTS: (keyof GlobalEventHandlersEventMap)[] = ['click', 'resize', 'scroll', 'contextmenu'];
